export default __webpack_public_path__ + "static/media/151-money-icons.cda94e85.png";